import React, { useCallback, useEffect, useState } from 'react';
import { Icon } from '@vectord/components';

import { UPLOAD_VIDEO_CONFIG } from '@assetManagement/data/uploadVideoConfig';
import FieldErrors from 'components/FieldErrors';
import Input from 'components/Input';
import styles from './UploadVideoModalBody.module.scss';
import UploadVideoInput from '../UploadVideoInput';
import validateVideo from '@assetManagement/utils/validateVideo';

export default function UploadVideoModalBody({
  selectedFile,
  onSelectFile,
  resetFile,
}) {
  const [inputErrors, setInputErrors] = useState(null);

  useEffect(() => {
    return () => {
      setInputErrors(null);
    };
  }, []);

  const onFileSelected = useCallback(
    async (files) => {
      const file = files[0];
      const errors = await validateVideo(file, UPLOAD_VIDEO_CONFIG);
      if (Object.keys(errors).length === 0) {
        setInputErrors(null);
        onSelectFile(file);
      } else {
        setInputErrors(errors);
      }
    },
    [onSelectFile]
  );

  if (selectedFile) {
    return (
      <div className={styles.selectedFileNameContainer}>
        <Input
          value={selectedFile.name}
          className={styles.selectedFileName}
          readOnly
        />
        <Icon
          name="clear"
          className={styles.closeIcon}
          onClick={resetFile}
        />
      </div>
    );
  } else {
    return (
      <>
        <UploadVideoInput onFileSelected={onFileSelected} />
        <FieldErrors
          name="uploadVideo"
          errors={inputErrors}
          prefixName={false}
        />
      </>
    );
  }
}
